import {
	type ChartConfig,
	ChartContainer,
	ChartTooltip,
	ChartTooltipContent,
} from "@d12labs/ui/chart";
import { CartesianGrid, Line, LineChart, XAxis, YAxis } from "recharts";
import { formatLocalDate } from "../format";

const config = {
	score: { label: "Flexibility", color: "var(--color-chart-1)" },
} satisfies ChartConfig;

/** Self-rated flexibility (1–10) over time — watch it come back over the race block. */
export function FlexibilityChart({ data }: { data: Array<{ date: string; score: number }> }) {
	if (data.length < 2) {
		return (
			<div className="flex h-[180px] items-center justify-center rounded-lg border border-dashed border-hairline text-sm text-ink-subtle">
				Log a couple of mobility sessions to see your flexibility trend.
			</div>
		);
	}
	return (
		<ChartContainer config={config} className="aspect-auto h-[180px] w-full">
			<LineChart data={data} margin={{ left: -16, right: 8, top: 8, bottom: 0 }}>
				<CartesianGrid vertical={false} />
				<XAxis
					dataKey="date"
					tickLine={false}
					axisLine={false}
					tickMargin={8}
					tickFormatter={formatLocalDate}
					minTickGap={24}
				/>
				<YAxis
					domain={[0, 10]}
					ticks={[0, 2, 4, 6, 8, 10]}
					tickLine={false}
					axisLine={false}
					width={32}
				/>
				<ChartTooltip
					content={<ChartTooltipContent labelFormatter={(l) => formatLocalDate(String(l))} />}
				/>
				<Line
					dataKey="score"
					type="monotone"
					stroke="var(--color-score)"
					strokeWidth={2}
					dot={{ r: 3 }}
					activeDot={{ r: 5 }}
				/>
			</LineChart>
		</ChartContainer>
	);
}
